import React from 'react'
import { Card as PPUICard } from '@paypalcorp/pp-react'

interface Props {
  title: string
  subHeader?: string
}

const StoreDetailsSidebarCard = ({ title, subHeader }: Props) => {
  return (
    <div className="store-details-sidebar" data-cy="storeDetailsSidebar">
      <PPUICard className="store-details-sidebar__tile">
        <PPUICard.Header className="store-details-sidebar__header">
          <div
            className="store-details-sidebar__text--body-strong"
            data-cy="storeDetailsSidebarTitle"
          >
            {title}
          </div>
        </PPUICard.Header>
        <PPUICard.Content>
          <div className="store-details-sidebar__text--body">{subHeader}</div>
        </PPUICard.Content>
      </PPUICard>
    </div>
  )
}

export default StoreDetailsSidebarCard
